(function () {
    'use strict';

    angular.module("imApp").factory("prepareBomsService", ['$ihttp', function ($ihttp) {
        let service = {
            getPrepareBoms: function (parms) {
                return $ihttp.post({
                    method: 2651,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();